import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  CommentParam,
  updateBillingOrderParam,
} from "features/stock-ordering/core/stock-ordering.params";
import {
  PostCommentRepository,
  PostCommentResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum PostCommentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: PostCommentState;
  message: string;
}

const initialState: InitialState = {
  status: PostCommentState.initial,
  message: "",
};

export const postComment = createAsyncThunk(
  "postComment",
  async (param: CommentParam, { rejectWithValue }) => {
    try {
      const response: PostCommentResponse = await PostCommentRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const postCommentSlice = createSlice({
  name: "postComment",
  initialState,
  reducers: {
    resetpostComment: (state) => {
      state.status = PostCommentState.initial;
      state.message = "Reset request";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postComment.pending, (state) => {
        state.status = PostCommentState.inProgress;
      })
      .addCase(postComment.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = PostCommentState.success;
          state.message = message;
        }
      })
      .addCase(postComment.rejected, (state, action) => {
        state.status = PostCommentState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectPostComment = (state: RootState) => state.postComment;

export const { resetpostComment } = postCommentSlice.actions;
export default postCommentSlice.reducer;
